export default "__VITE_ASSET__296699da__"